<ng-container *hasPermission="PermissionForStudents.COURSE_VIEW">
  <ng-container *ngIf="isLoading; else pageContent">
    <div class="app-spinner">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  </ng-container>

  <ng-template #pageContent>
    <div class="container-fluid p-3" *ngIf="courseDetails">
      <div class="row">
        <div class="col-12 p-2 mb-4">
          <div class="main-content">
            <div class="content mt-3">
              <div class="thumbnail-wrapper mb-5">
                <div
                  class="thumbnail-wrapper mb-5"
                  [ngClass]="{ 'no-image': !courseDetails.course_thumbnail }"
                  [style.backgroundImage]="
                    courseDetails.course_thumbnail
                      ? 'url(\'' + courseDetails.course_thumbnail + '\')'
                      : ''
                  "
                >
                  <div class="image-overlay">
                    <div class="top-overlay">
                      <div class="d-flex align-items-center">
                        <i
                          class="bi bi-arrow-left-short back-arrow"
                          (click)="goToProCourses()"
                        ></i>
                        <span class="badge">PROFESSIONAL PROGRAM</span>
                        <span class="badge">{{
                          courseDetails.grade_level || "N/A"
                        }}</span>
                      </div>
                    </div>
                    <div class="overlay-content">
                      <h3
                        class="text-truncate"
                        matTooltip="{{ courseDetails.course_title }}"
                      >
                        {{ courseDetails.course_title || "N/A" }}
                      </h3>

                      <span
                        class="tag mb-3 two-line"
                        matTooltip="{{ courseDetails.course_description }}"
                      >
                        {{ courseDetails.course_description || "N/A" }}</span
                      >
                      <div class="d-flex tags">
                        <p>
                          <i class="bi bi-people me-1"></i>
                          {{ courseDetails.student_count }} learners
                        </p>
                        <p>
                          <i class="bi bi-star text-warning ms-2 me-1"></i>
                          {{ courseDetails.rating }} rating
                        </p>
                        <!-- <p><i class="bi bi-clock ms-2 me-1"></i> {{courseDetails.course_duration}} hour</p> will used this later-->
                        <p>
                          <i class="bi bi-book ms-2 me-1"></i>
                          {{ courseDetails.total_units_count }} units
                        </p>
                      </div>

                      <div class="d-flex">
                        <ng-container
                          *hasPermission="PermissionForStudents.COURSE_ENROLL"
                        >
                          <button
                            type="button"
                            class="btn-add enroll"
                            (click)="postStudentEnroll()"
                            *ngIf="!courseDetails.is_enrolled"
                          >
                            Enroll Now
                          </button>
                        </ng-container>

                        <button
                          class="btn-add enroll"
                          (click)="
                            goToCourseDescriptionPage(courseDetails.course_id!)
                          "
                          *ngIf="courseDetails.is_enrolled"
                        >
                          Go to Course
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row font-name">
          <div class="col-12 col-lg-8">
            <div class="learn-card">
              <h5 class="learn-title">
                <span class="learn-icon">
                  <i class="bi bi-bullseye"></i> </span
                >What You'll Learn
              </h5>

              <div
                class="learn-list"
                *ngFor="let courseObjective of courseDetails.course_objectives"
              >
                <div class="learn-item">
                  <i class="bi bi-check-circle-fill"></i
                  >{{ courseObjective || "N/A" }}
                </div>
              </div>
            </div>

            <div class="accordion" id="curriculumAccordion">
              <div class="curriculum-header ms-1 mt-2 mb-3">
                <h5>Curriculum</h5>
              </div>
              <div
                class="accordion-item mb-2"
                *ngFor="let unit of courseDetails.units; let i = index"
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-button"
                    [class.collapsed]="openIndex !== i"
                    (click)="toggleAccordion(i)"
                  >
                    <span class="module-index">{{ i + 1 }}</span>
                    <div class="module-info">
                      <div class="module-title">
                        {{ unit.unit_title || "N/A" }}
                      </div>
                    </div>
                  </button>
                </h2>
                <div
                  class="accordion-collapse collapse"
                  [class.show]="openIndex === i"
                >
                  <div class="accordion-body">
                    <div class="lesson-row" *ngFor="let topic of unit.topics">
                      <div class="lesson-left">
                        <i class="bi bi-book"></i
                        >{{ topic.topic_title || "N/A" }}
                      </div>
                      <span class="lesson-time">
                        {{ unit.unit_hours }} min</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <div class="course-side-card mb-4">
              <h5
                class="course-title text-center mt-3 text-truncate"
                matTooltip="{{ courseDetails.course_title }}"
              >
                {{ courseDetails.course_title || "N/A" }}
              </h5>
              <div class="course-tags d-flex gap-3 mt-2 mb-4">
                <div class="rating">
                  <i class="bi bi-star-fill"></i
                  ><span> {{ courseDetails.rating }}</span>
                </div>
                <span class="dot">•</span>
                <div class="learners">
                  <span>{{ courseDetails.student_count }} learners</span>
                </div>
              </div>

              <div class="course-meta mb-4">
                <!-- <div><span>Duration</span><span>{{courseDetails.course_duration}}</span></div> will used this later -->
                <div>
                  <span>Modules</span
                  ><span>{{ courseDetails.units.length }}</span>
                </div>
                <div>
                  <span>Topic</span
                  ><span>{{ courseDetails.total_topics_count }}</span>
                </div>
                <div>
                  <span>Quizzes</span
                  ><span>{{ courseDetails.total_quizzes_count }}</span>
                </div>
              </div>

              <!-- <button class="btn-add w-100 mb-4" (click)="goToCourseDescriptionPage(courseDetails.course_id!)"
    [disabled]="!courseDetails.is_enrolled">
    Go to Course <i class="bi bi-arrow-right"></i>
  </button> -->

              <p class="access-note">Full access to all lessons and quizzes.</p>
            </div>
            <div class="course-side-card mb-4">
              <i class="bi bi-trophy me-3"></i>
              <span class="course-title">Talk to Industry Experts</span>
              <div class="ms-4">
                <p class="access-note text-start">
                  Book personalized 1-on-1 mentor sessions with experienced
                  professionals to get real-world guidance, career direction,
                  and interview preparation support.
                </p>
                <button
                  type="button"
                  class="btn-add m-0 w-100"
                  (click)="goToMentorSession()"
                >
                  Book Session
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
